import React from 'react'

// The Lottie library and animation load separately from the main bundle (IMP-088); AppForm prefetches
// them on the last question page so the animation is ready when Submit is pressed
const LoadingAnimation = React.lazy(() => import('./LoadingAnimation.js'));


export default function Popup(props) {
    const clickOutBehavior = (props.type === "error") ? { show: false, type: "" } : { show: true, type: "loading" }
    const title = (props.type === "error") ? "There was an issue with processing your results" : "Processing your results";
    const subtitle = (props.type === "error") ? "Click anywhere to dismiss. Try again by clicking submit." : "Do not exit to avoid any data loss.";
    return (
        <div className="Popup" onClick={() => props.handleTogglePopup(clickOutBehavior)}>
            <div className="Popup--container">
                <div className="Popup--image-container">
                    {props.type === "error" && <img className="Popup--image" src="/error.png" alt="Error" />}
                    {props.type === "loading" && <React.Suspense fallback={null}><LoadingAnimation /></React.Suspense>}
                </div>
                <h2 className="Popup--title">{title}</h2>
                <p className="Popup--subtitle">{subtitle}</p>
            </div>
        </div>
    )
}